import React, { useState, useEffect ,useRef} from 'react';
import { useDispatch, useSelector } from 'react-redux';
import LogoutModel from './LogoutModel';
import {
    flightSearchCredential,
    flightManifestBoardingCredential,
    flightTripBoardingCredential,
    selectedOriginDropdownCredential,
    selectedDestinationDropdownCredential,
    setflightLegKeyCredential,
    assistQueueCredential, moduleAndLoginDivDisabled
} from '../ReduxState';
import { Button, Modal } from 'react-bootstrap';
import { ToastContainer, toast } from 'react-toastify';
import { useHistory, useLocation } from 'react-router-dom';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { fncFlightSearchForBoarding, fncStationsApi, fncLoadFlightManifestDataForBoarding, fncGetTripStatus, fncClosePendingFlight, fncOpenFlight, fncCloseFlight, fncChangeBoardingGateNumber, fncGetStationTime } from '../Utility/ApiCall.js';
import { flightsearchPageIconsMapping, monthNames, pageNavigationForBoardingModule, mapToProp, shortcutKeyForBoardingsPage, shortcutKeysBoarding, statusForGateChangeAction, fncFocusElementDependsOnPathLocation } from '../Utility/CommonFun';
import '../Scss/_boarding.scss';
import FocusLock from "react-focus-lock";

function Notification() {
    
    const dropdownRef = useRef(null);
    const [selectedValue, setSelectedValue] = useState("");
    const [sortingsectionFocus, setsortingsectionFocus] = useState(false);
    const selectRef = useRef(null);
    const modalRef = useRef(null);
    const [indx, setindx] = useState(0);
    const [Tabledisabled, setTableDisabled] = useState(true); // Controls FocusLock
    const [searchddisable, setsearchddisable] = useState(false); // Controls FocusLock
    const tblrow = useRef([]);
    const changegatenoref = useRef(null);
    const datePickerRef = useRef(null); // Create a ref for DatePicker
    const searchvalref = useRef(null); // Create a ref for DatePicker
    const changeGateRefs = useRef([]); // Create a ref for DatePicker
    const [changeGateRefsIndex,setchangeGateRefsIndex]=useState(0);
    const dispatch = useDispatch();
    const history = useHistory();
    const location = useLocation();
    const sortByFlightList = {
        departure: 'Departure Time',
        arrival: 'Arrival Time',
        status: 'Status',
        flight: 'Flight'
    }
    const startDate = new Date();
    const endDate = new Date();
    const Location = useSelector(state => state.login.Location);
    const [triggerModal, settriggerModal] = useState(false);
    const ReduxDestinationDropdown = useSelector(state => state.selectedpassenger.DestinationDropdown);
    const ReduxOriginDropdown = useSelector(state => state.selectedpassenger.OriginDropdown);
    const flightList = useSelector(state => state.flightSearch.flightList);
    const [flights, setFlights] = useState(flightList && flightList.length === 0 ? [] : flightList)
    const [searchValue, setsearchValue] = useState('');
    const [isAdvance, setisAdvance] = useState(false);
    const [origin, setOrigin] = useState(Location === 'HDQ' ? 'DEL' : Location);
    const [destination, setDestination] = useState('');
    const [st_date, setDateToSearch] = useState(new Date());
    const [dateRangeStart, setdateRangeStart] = useState(startDate.setDate(startDate.getDate() - 1));
    const [dateRangeEnd, setdateRangeEnd] = useState(endDate.setDate(endDate.getDate() + 1));
    const [st_ErrorDate, setErrorDate] = useState('');
    const [st_ErrorOrigin, setErrorOrigin] = useState('');
    const [flightnum, setFlightNum] = useState('');
    const [opsuffix, setOPSuffix] = useState('');
    const [selectedRow, setSelectedRow] = useState(-1);
    const [isLoadFlightAvailable, setIsLoadFlightAvailable] = useState(true);
    const [gate, setGate] = useState('');
    const [sendNotification, setsendNotification] = useState(false);
    const [showGateChangePopup, setGateChangePopup] = useState(false);
    const [open, setOpen] = useState(true);
    const [close, setClose] = useState(true);
    const [closePending, setClosePending] = useState(true);
    const [sortHeading, setSortHeading] = useState(sortByFlightList['departure']);
    const flightManifest = useSelector(state => state.flightSearch.flightManifestBoarding);
    const flightTripBoarding = useSelector(state => state.flightSearch.flightTripBoarding);
    const assistErrorQueue = useSelector(state => state.flightSearch.assistQueue);
    const selectedLeg = useSelector(state => state.flightSearch.selectedFlight);
    const IsModulAndLoginDivDisabled = useSelector(state =>state.login.IsModulAndLoginDivDisabled);

    console.log('isAdvance------', flightManifest, flightTripBoarding);
    const notify = (e) =>
        toast.error(e, {
            position: "top-right",
            autoClose: 5000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    const notifySuccess = (e, close = 5000) =>
        toast.success(e, {
            position: "top-right",
            autoClose: close,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
        });

    useEffect(() => {
        // console.log('document.getElementById("loadFlight")', document.getElementById("loadFlight"), document.getElementById("loadFlight").disabled);
        document.addEventListener("keyup", function (event) {
            if (event.key === 'Enter') {
                if (selectedRow !== -1
                    && document.getElementById("loadFlight") && document.getElementById("loadFlight").disabled == false) {
                    document.getElementById("loadFlight").click();
                }
                if (document.getElementById('searchBar') && searchValue !== '') {
                    document.getElementById("searchBar").click();
                }
            }
        });
    }, [selectedRow, searchValue]);

    // useEffect(() => {
    //     if (selectedLeg && flightManifest) {
    //         document.addEventListener("keydown", shortcutKeyHandler);
    //     }

    //     // cleanup this listener
    //     return () => {
    //         document.removeEventListener('keydown', shortcutKeyHandler);
    //     };
    // }, [selectedLeg, selectedRow, flightManifest]);

    // const shortcutKeyHandler = (e) => {
    //     // debugger
    //     if (e.key && shortcutKeysBoarding.includes(e.key)) {
    //         const path = shortcutKeyForBoardingsPage(location.pathname, e);
    //         if (path) {
    //             history.push('/' + path);
    //         }
    //     }
    // }

    useEffect(() => {
        // debugger
        if (flightManifest || flightTripBoarding || assistErrorQueue.length) {
            dispatch(flightManifestBoardingCredential(
                {
                    type: '',
                    flightManifestBoarding: null
                }
            ))
            dispatch(flightTripBoardingCredential(
                {
                    type: '',
                    flightTripBoarding: null
                }
            ))
            dispatch(assistQueueCredential(
                {
                    type: "",
                    assistQueue: [],
                }
            ))
        }

        if (ReduxDestinationDropdown.length === 0 || ReduxOriginDropdown.length === 0) {
            fncStationsApi()
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //     notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {

                            dispatch(selectedOriginDropdownCredential(
                                {
                                    type: "",
                                    OriginDropdown: returnVal.data.stations,

                                }))
                            dispatch(selectedDestinationDropdownCredential(
                                {
                                    type: "",
                                    DestinationDropdown: returnVal.data.stations
                                }))
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                })
                .catch(err => console.log("Axios err: ", err));
        }
    }, []);

    useEffect(() => {
        // debugger
        if (flights && flights.length === 0) {
            const apiData = {
                beginDate: new Date(),
                originStations: Location === 'HDQ' ? ['DEL'] : [Location],
                destinationStations: [""],
                identifier: "",
                carrierCode: process.env.REACT_APP_AirlineCode
            }
            fncFlightSearchForBoarding(apiData)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {

                            dispatch(flightSearchCredential(
                                {
                                    type: "",
                                    flightList: returnVal.data.flightData,
                                }))
                            setFlights(returnVal.data.flightData);
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                })
                .catch(err => console.log("Axios err: ", err));
        }
    }, []);

    const formatAMPM = (date) => {
        date = new Date(date);
        var hours = date.getHours();
        var minutes = date.getMinutes();
        var ampm = hours >= 12 ? 'pm' : 'am';
        hours = hours % 12;
        hours = hours ? hours : 12; // the hour '0' should be '12'
        minutes = minutes < 10 ? '0' + minutes : minutes;
        var strTime = hours + ':' + minutes + ' ' + ampm;
        return strTime;
    };

    const getStatusText = (status) => {
        let statusText;
        switch (status) {
            case '0':
                statusText = 'Boarding';
                break;
            case '1':
                statusText = 'Closed';
                break;
            case '2':
                statusText = 'Cancelled';
                break;
            case '3':
                statusText = 'Suspended';
                break;
            case '5':
                statusText = 'ClosedPending';
                break;
            case '6':
                statusText = 'BlockAllActivities';
                break;
            case '7':
                statusText = 'Mishap';
                break;
            default:
                statusText = '';
                break;
        }
        return statusText;
    }

    const isActionEnabled = (flight) => {
        console.log('flight isActionEnabled', flight);
        const statusText = getStatusText(flight.legDetails.status);
        if (statusForGateChangeAction.includes(statusText)) {
            return true;
        } else {
            return false;
        }
    }

    const sortBy = (sortBy) => {
        let flightListBySorting = [...flights];
        switch (sortBy) {
            case 'departure':
                flightListBySorting.sort(function (a, b) {
                    return new Date(a.designator.departure) - new Date(b.designator.departure);
                });
                break;
            case 'arrival':
                flightListBySorting.sort(function (a, b) {
                    return new Date(a.designator.arrival) - new Date(b.designator.arrival);
                });
                break;
            case 'status':
                flightListBySorting.sort(function (a, b) {
                    return (a.legDetails.status - b.legDetails.status);
                });
                break;
            case 'flight':
                flightListBySorting.sort(function (a, b) {
                    return (a.identifier.identifier - b.identifier.identifier);
                });
                break;
            default:
                flightListBySorting = [...flightList];
                break;
        }
        setSortHeading(sortByFlightList[sortBy]);
        setFlights(flightListBySorting);
    };

    const fncSearchButtonIconClick = () => {
        // debugger
        const flightArray = [...flights];
        const filteredFlightList = [];
        const objecttTolook = ['designator', 'identifier'];
        if (searchValue !== '') {
            flightArray.forEach((obj) => {
                const keys = Object.keys(obj);
                keys.forEach((key, index) => {
                    if (objecttTolook.includes(key)) {
                        const innerObject = obj[key];
                        const innerKeys = Object.keys(innerObject);
                        innerKeys.forEach((k, i) => {
                            if (innerObject[k] !== null && innerObject[k].toLowerCase().indexOf(searchValue.toLowerCase()) > -1) {
                                filteredFlightList.push(obj);
                            }
                        })
                    }
                });
            });
            // console.log('Result: ', filteredFlightList);
            setFlights(filteredFlightList);
        } else {
            setFlights(flightList);
        }
    }

    const fncOnchange = (e) => {
        const { value, id } = e.target;
        if (id === 'SEARCHVALUE') {
            if (value === '') {
                setsearchValue('');
                setFlights(flightList);
            } else {
                setsearchValue(value);
            }

        }
        if (id === "fnumber") {
            if (value !== '') {
                if (/^[0-9]+$/.test(value)) {
                    if (value.length <= 5) {
                        setFlightNum(value);
                    }
                }
            }
            else {
                setFlightNum(value);
            }
        }
        if (id === "opSuffix") {
            setOPSuffix(value);
        }
    }

    const fncAdvanceSearch = (e) => {
        // debugger
        // console.log('fncAdvanceSearch', e.target.checked);

        setisAdvance(e.target.checked);
        // i have released focus of flights table if i will do onclick operation then focus go to datepicker
        setTableDisabled(true);
    }

    const fncOriginChange = (e) => {
        var originID = e.target.value;
        if (originID.toUpperCase() == "Select a Origin".toUpperCase()) {
            originID = "";
        }
        setErrorOrigin("");
        setOrigin(originID);
    }

    const fncDestinationChange = (e) => {

        // console.log(e);
        var DestinationValue = e.target.value;
        var DestinationID = e.target.id;
        if (DestinationValue.toUpperCase() == "Select a Destination".toUpperCase()) {
            DestinationValue = "";
        }
        setDestination(DestinationValue);
    }

    const handleDateChange = (e) => {
        // console.log(e);
        setErrorDate('');
        setDateToSearch(e);
    }

    const handleDateSelect = (e) => {
        setErrorDate('');
        setDateToSearch(e);
    }

    const fncSearchButtonClick = (from) => {
        // console.log('from', from);
        // console.log('=---', st_date, origin, destination, flightnum);
        debugger
        if (isAdvance) {
            const apiData = {
                beginDate: st_date,
                originStations: [origin],
                destinationStations: [destination],
                identifier: flightnum,
                carrierCode: process.env.REACT_APP_AirlineCode
            }
            fncFlightSearchForBoarding(apiData)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    }
                    else {
                        if (returnVal.data.isError == false) {

                            dispatch(flightSearchCredential(
                                {
                                    type: "",
                                    flightList: returnVal.data.flightData,
                                }))
                            setFlights(returnVal.data.flightData);
                            setisAdvance(false);
                        }
                        else {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                    settriggerModal(true);
                            } else {
                                    notify(returnVal.data.errorDetail.errorMessage);
                            }
                        }
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                })
                .catch(err => console.log("Axios err: ", err));
        }
    }

    const loadFlightData = async (flightIndex) => {
        const selectedFlight = flightIndex !== -1 ? flights.find((item, index) => index === flightIndex) : null;
        console.log('selectedlegKey', selectedFlight.legKey);
        if (selectedFlight && selectedFlight.legKey) {
            setSelectedRow(flightIndex);
            try {
                // const manifestData = await fncLoadFlightManifestDataForBoarding(selectedFlight.legKey);
                const tripData = await fncGetTripStatus(selectedFlight.legKey, false, true);
                if (tripData.status == "401" && tripData.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //notify(returnVal.statusText);
                    settriggerModal(true);
                } else {
                    if (!tripData.data.isError) {
                        const { destinationDetails, operationDetails, originDetails, isInternational, irop } = tripData.data;
                        console.log('tripData', tripData.data, ' operationDetails ', operationDetails, 'originDetails', originDetails)
                        if (operationDetails.tripOperationTimes && operationDetails.tripOperationTimes.departureTimes) {
                            let currentTime = new Date();
                            let depTime = operationDetails.tripOperationTimes.departureTimes.estimated
                                ? operationDetails.tripOperationTimes.departureTimes.estimated
                                : operationDetails.tripOperationTimes.departureTimes.scheduled;
                            if (isInternational) {
                                fncGetStationTime(originDetails.station)
                                    .then((resultTimestamp) => {
                                        if (resultTimestamp.status === 200) {
                                            console.log('resultTimestamp', new Date(resultTimestamp.data));
                                            currentTime = new Date(resultTimestamp.data);
                                        } else {
                                            notify('Something went wrong in fncGetStationTime');
                                        }
                                    })
                                    .catch((e) => {
                                        console.log('error in fncGetStationTime', e);
                                        document.getElementById("showAndHideSpinner").style.display = "none";
                                        notify(e.message);
                                    })
                            }
                            const currentTimeStamp = currentTime.getTime();
                            const depTimeStamp = new Date(depTime).getTime();
                            const diff = currentTimeStamp - depTimeStamp;
                            console.log('currentTime', currentTime, currentTime.getTime(), 'depTime', depTime, new Date(depTime).getTime(), 'diff', currentTime.getTime() - new Date(depTime).getTime());                         
                            if (diff > 0) {
                                // const myModal = document.querySelector('.modal');
                                // document.getElementById('changeGate').hide();
                                // myModal.hide()
                                // document.getElementById("gateChangeCancelButton").click(); 
                                notify('Cannot change the gate number as the current time is exceeding the departure time.')
                            } else {
                                setGateChangePopup(true);
                                setGate(originDetails.gate.estimatedGate ? originDetails.gate.estimatedGate : '');
                            }
                        }
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        notify(tripData.data.errorDetail.errorMessage);
                    }
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    // dispatch(setflightLegKeyCredential({
                    //     type: '',
                    //     selectedFlight: selectedFlight.legKey
                    // }));
                    // const navPage = pageNavigationForBoardingModule('FlightSearch');
                    // history.push("/" + navPage);
                }
            } catch (e) {
                console.log('error in loading flight data', e);
                document.getElementById("showAndHideSpinner").style.display = "none";
                notify(e.message);
            }
        }
    }

    const fncChangeGateNumber = (e) => {
        var alphaNumeric = /^[0-9a-zA-Z]+$/;
        console.log('fncChangeGateNumber', e.target.value);
        const val = e.target.value;
        if (val != "") {
            if (val.match(alphaNumeric)) {
                if (val.length <= 5) {
                    setGate(val);
                }
            }
        }
        else {
            setGate(val);
        }
    }

    const fncSendNotification = (e) => {
        console.log('fncSendNotification', e.target.checked)
        setsendNotification(e.target.checked)
    }

    const fncSubmitGateChangeRequest = () => {
        // console.log('fncSubmitGateChangeRequest', gate, sendNotification, selectedRow);
        const selectedFlight = selectedRow !== -1 ? flights.find((item, index) => index === selectedRow) : null;
        console.log('selectedlegKey', selectedFlight);
        // fncChangeBoardingGateNumber
        if (gate !== '') {
            const apiBody = {
                LegKey: selectedFlight.legKey,
                DepartureDate: new Date(selectedFlight.designator.departure),
                CarrierCode: selectedFlight.identifier.carrierCode,
                FlightNumber: selectedFlight.identifier.identifier,
                DepartureStation: selectedFlight.designator.origin,
                ArrivalStation: selectedFlight.designator.destination,
                departureGate: gate,
                Notification: sendNotification
            }
            fncChangeBoardingGateNumber(apiBody)
                .then((returnVal) => {
                    if (returnVal.status == "401" && returnVal.data == "") {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        //notify(returnVal.statusText);
                        settriggerModal(true);
                    } else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (!returnVal.data.isError) {
                            if (sendNotification) {
                                notifySuccess('Change Gate number notification has been sent successfully.');
                            } else {
                                notifySuccess('Change Gate number request has been completed successfully.');
                            }
                            setGateChangePopup(false);
                        } else {
                            notify(returnVal.data.errorDetail.errorMessage);
                        }
                    }
                })
                .catch(err => console.log('axios err in fncSubmitGateChangeRequest', err));
        } else {
            notify('Gate number is not provided to update.')
        }
    }

    const callFlightSearch = (apiRequest) => {
        fncFlightSearchForBoarding(apiRequest)
            .then((returnVal) => {
                if (returnVal.status == "401" && returnVal.data == "") {
                    document.getElementById("showAndHideSpinner").style.display = "none";
                    //notify(returnVal.statusText);
                    settriggerModal(true);
                }
                else {
                    if (returnVal.data.isError == false) {

                        dispatch(flightSearchCredential(
                            {
                                type: "",
                                flightList: returnVal.data.flightData,
                            }))
                        setFlights(returnVal.data.flightData);
                        setOpen(true);
                        setClose(true);
                        setClosePending(true);
                    }
                    else {
                        document.getElementById("showAndHideSpinner").style.display = "none";
                        if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                settriggerModal(true);
                        } else {
                                notify(returnVal.data.errorDetail.errorMessage);
                        }
                    }
                }
                document.getElementById("showAndHideSpinner").style.display = "none";
            })
            .catch(err => console.log("Axios err: ", err));
    }

    const fncFlightOptions = (option) => {
        const selectedFlight = selectedRow !== -1 ? flights.find((item, index) => index === selectedRow) : null;
        let apiData = {
            beginDate: new Date(),
            originStations: Location === 'HDQ' ? ['DEL'] : [Location],
            destinationStations: [""],
            identifier: "",
            carrierCode: process.env.REACT_APP_AirlineCode
        }

        if (st_date || origin || destination || flightnum) {
            apiData = {
                beginDate: st_date,
                originStations: origin ? [origin] : Location === 'HDQ' ? ['DEL'] : [Location],
                destinationStations: destination ? [destination] : [""],
                identifier: flightnum ? flightnum : "",
                carrierCode: process.env.REACT_APP_AirlineCode
            }
        }

        if (selectedFlight && selectedFlight.legKey) {
            if (option === 'ClosePending') {
                fncClosePendingFlight(selectedFlight.legKey)
                    .then((returnVal) => {
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        }
                        else {
                            if (returnVal.data.isError == false) {
                                // notifySuccess('Close pending done');
                                callFlightSearch(apiData);
                            }
                            else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                        notify(returnVal.data.errorDetail.errorMessage);
                                }
                            }
                        }
                        document.getElementById("showAndHideSpinner").style.display = "none";
                    })
                    .catch(err => console.log("Axios err: ", err));
            }
            if (option === 'Close') {
                fncCloseFlight(selectedFlight.legKey)
                    .then((returnVal) => {
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        }
                        else {
                            if (returnVal.data.isError == false) {
                                // notifySuccess('Close done');
                                callFlightSearch(apiData);
                            }
                            else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                        notify(returnVal.data.errorDetail.errorMessage);
                                }
                            }
                        }
                        document.getElementById("showAndHideSpinner").style.display = "none";
                    })
                    .catch(err => console.log("Axios err: ", err));
            }
            if (option === 'Open') {
                fncOpenFlight(selectedFlight.legKey)
                    .then((returnVal) => {
                        if (returnVal.status == "401" && returnVal.data == "") {
                            document.getElementById("showAndHideSpinner").style.display = "none";
                            //notify(returnVal.statusText);
                            settriggerModal(true);
                        }
                        else {
                            if (returnVal.data.isError == false) {
                                // notifySuccess('Open done');
                                callFlightSearch(apiData);
                            }
                            else {
                                document.getElementById("showAndHideSpinner").style.display = "none";
                                if (fncCheckIfTokenIsExpired(returnVal.data.errorDetail)) {
                                        settriggerModal(true);
                                } else {
                                        notify(returnVal.data.errorDetail.errorMessage);
                                }
                            }
                        }
                        document.getElementById("showAndHideSpinner").style.display = "none";
                    })
                    .catch(err => console.log("Axios err: ", err));
            }
            setSelectedRow(-1);
        }
    }

    const selectRow = (index) => {
        debugger
        // if (selectedRow === index) {
        //     setOpen(true);
        //     setClosePending(true);
        //     setClose(true);
        //     setSelectedRow(-1);
        //     setIsLoadFlightAvailable(true);
        // } else {
        //     const selectedFlight = index !== -1 ? flights.find((item, i) => i === index) : null;
        //     if (selectedFlight && selectedFlight.legKey) {
        //         const flightStatus = getStatusText(selectedFlight.legDetails.status);
        //         console.log('flightStatus', flightStatus);
        //         if (flightStatus !== 'Cancelled') {
        //             setIsLoadFlightAvailable(false);
        //         } else {
        //             setIsLoadFlightAvailable(true);
        //         }
        //         // console.log('flightStatus', flightStatus);
        //         if (flightStatus === 'Boarding') {
        //             setClose(false);
        //             setClosePending(false);
        //         }
        //         else if (flightStatus === 'Closed') {
        //             setOpen(false);
        //             setClosePending(false);
        //         }
        //         else if (flightStatus === 'ClosedPending' || flightStatus === 'BlockAllActivities') {
        //             setClose(false);
        //             setOpen(false);
        //         } else {
        //             setOpen(true);
        //             setClose(true);
        //             setClosePending(true);
        //         }
        //     }
        setSelectedRow(index);
        // }
    }

    function fncPopupCancelClick() {
        setGateChangePopup(false);
    }


    const handleDropdownItemKeyDown = (e, option) => {
             
        if (e.key === "Enter") {
            e.preventDefault();
            sortBy(option); // Trigger sorting
            closeDropdown();
            if(flights.length > 0){
                let firstbtn=flights.findIndex(item => item.legDetails.status === "0");
              if( tblrow.current){
                tblrow.current[firstbtn].focus();
              }
            }
        }
     
        // else if (e.key === "Escape") {
        //   document.getElementById("profile")?.focus();
        // }
      };
      const closeDropdown = () => {
        if (dropdownRef.current) {
            dropdownRef.current.classList.remove("show");
            document.getElementById("profile").setAttribute("aria-expanded", "false");
        }
      };
      

      const   handlefocus=() => {
        const amountInput = document.getElementById("SEARCHVALUE");
        if (amountInput) {
          amountInput.focus();
        }
    }



 useEffect(() => {
    if (!showGateChangePopup) {
    
        if(searchvalref.current){
            searchvalref.current.focus();
        }

    }
}, [showGateChangePopup]);


useEffect(() => {
    if (isAdvance ) {
            if (datePickerRef.current) {
                datePickerRef.current.setFocus(); // React DatePicker has a setFocus() method
            }
    }
}, [isAdvance]);

useEffect(() => {
    const handleKeyDown = (event) => {
        if (event.altKey && event.key.toLowerCase() === 'c') {
                                        if(!IsModulAndLoginDivDisabled){
                                            setsearchddisable(false);
                                            dispatch(moduleAndLoginDivDisabled({
                                                type: "MODULE_AND_LOGINDIV_DISABLED",
                                                IsModulAndLoginDivDisabled: true
                                            }));
                                            fncFocusElementDependsOnPathLocation(location.pathname,searchvalref.current);
                                            setTableDisabled(true);
                                        }else if (IsModulAndLoginDivDisabled) {
                                            setsearchddisable(true);
                                            const headingDiv = document.querySelector(".modulebtn");            
                                            if (headingDiv) {                  
                                                headingDiv.focus();
                                                dispatch(moduleAndLoginDivDisabled({
                                                        type: "MODULE_AND_LOGINDIV_DISABLED",
                                                        IsModulAndLoginDivDisabled: false
                                                    }));
                                            }
                                        }
                    }
        else if (event.shiftKey && event.key === "ArrowUp") {
            setTableDisabled(true);
            event.preventDefault(); // Prevents default scrolling behavior
            if (searchvalref.current) {
                searchvalref.current.focus();
            }
        }
        if (event.shiftKey && event.key === "ArrowDown") {
            setsortingsectionFocus(false);
            setTableDisabled(false);
            console.log(flights,"flights",)
            if(flights.length > 0){
            let firstbtn=flights.findIndex(item => item.legDetails.status === "0");
            if( tblrow.current){
            tblrow.current[firstbtn].focus();
            }
         }       
        }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
        document.removeEventListener("keydown", handleKeyDown);
    };
}, [flights, IsModulAndLoginDivDisabled]);

         const handleChange = (e) => {
            const selectedOption = e.target.value;
            setSelectedValue(selectedOption);
            sortBy(selectedOption); // Call sorting function
        };
        const handleClick = () => {
            setsortingsectionFocus(true);
                setTableDisabled(true);
          
        };
        const handleinputSearchClick = () => {
    setTableDisabled(true); //to release focus traped inside flights table          
        };

        const handleButtonNavigation = (e, index) => {
            if (!tblrow.current || tblrow.current.length === 0) return;
        
            let newIndex = index;
        
            if (e.key === "ArrowUp") {
                e.preventDefault();
                do {
                    newIndex = newIndex > 0 ? newIndex - 1 : tblrow.current.length - 1;
                } while (!tblrow.current[newIndex]); // Skip rows without buttons
            } 
            else if (e.key === "ArrowDown") {
                e.preventDefault();
                do {
                    newIndex = newIndex < tblrow.current.length - 1 ? newIndex + 1 : 0;
                } while (!tblrow.current[newIndex]); // Skip rows without buttons
            }
        
            tblrow.current[newIndex]?.focus();
        };
        
   useEffect(()=>{
    if(sortingsectionFocus){
        if (selectRef.current) {
            selectRef.current.focus(); // Ensure focus on select when clicked
            if (searchvalref.current) {
                searchvalref.current.blur(); // Blur only if searchvalref is not null
            }        }
    }
   },[sortingsectionFocus])

    return (
        <div>
            <LogoutModel trigger={triggerModal}> </LogoutModel>
            <div class="full-container">
                <div class="card mt-3 pt-3 boarding">
                <FocusLock disabled={isAdvance ? true : searchddisable}>
                    <div class="search-outer primary">
                        <div class="search">
                            <input class="font-md focusClass input-box1" type="text"  ref={searchvalref}  id="SEARCHVALUE" name="search" value={searchValue} 
                            onChange={(e) => {fncOnchange(e);  }}
                            onClick={handleinputSearchClick} placeholder="Type Search Terms" />
                            <div class="icon">
                                <img src="newImages/search-dark.svg" id="searchBar" alt="icon-search" onClick={() => { fncSearchButtonIconClick() }} />
                            </div>
                        </div>
                        <div class="search-checkbox justify-content-between">
                            <div class="font-md">
                                <input class="form-check-input  checkbox-input" tabindex={0} name="flighSearchBooarding" type="checkbox" id="advanceSearchCheck" onChange={(e) => { fncAdvanceSearch(e) }} checked={isAdvance} />
                                <label class="form-check-label font-md white-text" for='advanceSearchCheck'>
                                    Advance Search
                            </label>
                            </div>
                            <div class="boardingSort">
                                <p class="font-sm bold white-text mb-1">Sort By </p>
                                <div className="dropdown-selector">
            <select
                id="dropdown"
                className="form-select"
                value={selectedValue}
                onChange={handleChange}
                onClick={handleClick}
                ref={selectRef}
            >
                {/* <option value="" disabled>{sortHeading}</option> */}
                <option value="departure">Departure Time</option>
                <option value="arrival">Arrival Time</option>
                <option value="status">Status</option>
                <option value="flight">Flight</option>
            </select>
        </div>
                            </div>
                        </div>

                    </div>
                    </FocusLock>

                    {
                        isAdvance ?
                            <div class="notificationAdvanceSearch" id="advanceSearchContent"
                             style={{ maxHeight: '80vh', overflowY: 'auto' }}
                             >
                                <h4 class="dark-text bold font-xxl mb-3">Advance Search</h4>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 mb-4 ">
                                        {/* <div class="form-floating date ">
                                    <input type="text" class="form-control" id="dateInput" placeholder="DD/MM/YYYY" />
                                    <span class="icon">
                                        <img class="icon-24" src="./assets/images/icon-date.svg"/>
                                    </span>
                                    <label for="dateInput">Date</label>
                                </div> */}
                                        <div class="form-floating date ">
                                            <DatePicker
                                                ref={datePickerRef} // Attach ref here

                                                autocomplete="new-date"
                                                name="date"
                                                className="form-control"
                                                dateFormat="dd-MM-yyyy"
                                                selected={st_date}
                                                minDate={dateRangeStart}
                                                maxDate={dateRangeEnd}
                                                onSelect={(e) => { handleDateSelect(e) }}
                                                onChange={(e) => { handleDateChange(e) }}
                                            />
                                            <span class="icon">
                                                <img class="icon-24" src="newImages/icon-date.svg" />
                                            </span>
                                            <p className="clsErrorDate" >{st_ErrorDate}</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 mb-4 ">
                                        <div class="departure">
                                            <div class="icon">
                                                <img src="newImages/departure.svg" alt="departure" />
                                            </div>
                                            <div class="form-floating">
                                                {/* <select class="form-select" id="origin" aria-label="origin">
                                            <option>Select</option>
                                            <option value="1">Delhi</option>
                                            <option value="2">Bangalore</option>
                                            <option value="3">Mumbai</option>
                                        </select> */}
                                                <select class="form-select focusClass" value={origin} onChange={e => fncOriginChange(e)} id="origin" aria-label="origin">
                                                    <option id="0">Select a Origin</option>
                                                    {
                                                        ReduxOriginDropdown.length === 0 ? '' : ReduxOriginDropdown.map((dest, i) =>
                                                            <option id={dest.stationCode}>{dest.stationCode}</option>
                                                        )
                                                    }
                                                </select>
                                                <label>Origin</label>
                                            </div>
                                            <p className="clsError" >{st_ErrorOrigin}</p>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 mb-4">
                                        <div class="arrival">
                                            <div class="icon">
                                                <img src="newImages/arrival.svg" alt="arrival" />
                                            </div>
                                            <div class="form-floating ">
                                                {/* <select class="form-select" id="destination" aria-label="destination">
                                            <option>Select</option>
                                            <option value="1">Delhi</option>
                                            <option value="2">Bangalore</option>
                                            <option value="3">Mumbai</option>
                                        </select> */}
                                                <select class="form-select focusClass" value={destination} onChange={e => fncDestinationChange(e)} id="destination" aria-label="destination">
                                                    <option id="0">Select a Destination</option>
                                                    {
                                                        ReduxDestinationDropdown.length === 0 ? '' : ReduxDestinationDropdown.map((dest, i) =>
                                                            <option id={dest.stationCode}>{dest.stationCode}</option>
                                                        )
                                                    }
                                                </select>
                                                <label for="destination">Destination</label>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-lg-4 col-md-6 mb-4 ">
                                        <div class="form-floating  ">
                                            {/* <input type="text" class="form-control" id="carrier" placeholder="Carrier" /> */}
                                            <select class="form-select" tabIndex={-1}>
                                                <option id={process.env.REACT_APP_AirlineCode}>{process.env.REACT_APP_AirlineCode}</option>
                                            </select>
                                            <label for="carrier">Carrier</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 mb-4 ">
                                        <div class="form-floating  ">
                                            <input type="text" class="form-control focusClass" id="fnumber" onChange={(e) => { fncOnchange(e) }} value={flightnum} placeholder="Flight Number" />
                                            <label for="fnumber">Flight Number</label>
                                        </div>
                                    </div>
                                    <div class="col-lg-4 col-md-6 mb-4 ">
                                        <div class="form-floating  ">
                                            <input type="text" class="form-control focusClass" id="opSuffix" placeholder="Op Suffix" onChange={(e) => { fncOnchange(e) }} value={opsuffix} />
                                            <label for="opSuffix">Op Suffix</label>
                                        </div>
                                    </div>
                                </div>

                                <div class="d-flex justify-content-end mt-3 ">
                                    <button id="searchBooking" 
                                    // tabIndex={0}
                                     onClick={() => { fncSearchButtonClick("ONPOPUP") }} class="btn btn-primary btn-animation me-4 SerachBtn">
                                        <span class="px-4">Search</span>
                                    </button>
                                    <button id="cancelAdvanceSearch"  onBlur={handlefocus} 
                                    // tabIndex={0}
                                     onClick={() => setisAdvance(false)} class="btn btn-primary btn-animation SerachBtn">
                                        <span class="px-4">Cancel</span>
                                    </button>
                                </div>
                            </div> : null
                    }
                    <div class={`searchContent ${isAdvance ? 'hide-div' : ''}`}>
                        <h4 class="dark-text bold font-xxl mb-3">Search</h4>
                        <div class="searchTable">
                        <FocusLock disabled={Tabledisabled}>

                            <table>
                                <thead>
                                    <tr>
                                        <th></th>
                                        <th>Flight</th>
                                        <th>Route</th>
                                        <th>Date</th>
                                        <th>Departure/Arrival</th>
                                        <th>Status</th>
                                        <th>Action</th>
                                    </tr>
                                </thead>
                                {
                                    flights.length ?
                                        flights && flights.length && flights.map((item, i) =>
                                            <tbody key={i}
                                            >
                                                
                                                <tr
                                                // tabIndex={0}
                                                // ref={(el) => (tblrow.current[i] = el)}  
                                                //  ref={tblrow} 
                                                key={i} style={selectedRow === i ? { 'backgroundColor': '#F6C1B1' } : { '': '' }}  >
                                                    {/* onClick={() => { selectRow(i) }} */}
                                                    <td>{i + 1}</td>
                                                    <td>
                                                        <div class="flightContent">
                                                            <img class="me-2" src={flightsearchPageIconsMapping[item.legDetails.status]} alt={item.legDetails.status} />
                                                            {`${item.identifier.carrierCode} ${item.identifier.identifier}`}
                                                        </div>
                                                    </td>
                                                    <td>{item.designator.origin} to {item.designator.destination}</td>
                                                    <td>{("0" + new Date(item.designator.departure).getDate()).slice(-2) + " " + monthNames[new Date(item.designator.departure).getMonth()]} </td>
                                                    <td>{formatAMPM(item.designator.departure)} - {formatAMPM(item.designator.arrival)}</td>
                                                    <td class={item.legDetails.status === '0' ? 'boarding' : 'Cancelled'}>
                                                        {getStatusText(item.legDetails.status)}
                                                    </td>
                                                    <td>
                                                        {
                                                            isActionEnabled(item)
                                                                ?
                                                                <button 
                                                                key={i} 
                                                                ref={(el) => (tblrow.current[i] = el)}  
                                                                tabIndex={0}
                                                                    class="OrangeShadow"
                                                                    onClick={() => loadFlightData(i)}
                                                                    onKeyDown={(e) => handleButtonNavigation(e, i)} // Handle arrow navigation

                                                                >
                                                                    <img src='images/GateChangeIcon.svg' />
                                                                </button>
                                                                :
                                                                null
                                                        }
                                                    </td>
                                                </tr>
                                            </tbody>
                                        ) :
                                        <tr className="noresultErrormessage">No result found. Please refine your search terms</tr>
                                }

                            </table>
                        </FocusLock>                                                                          
                        </div>
                        {/* <div class="searchFooter">
                            <div class="flight-status">
                                <div class="heading">
                                    <h4 class="dark-text bold font-lg">
                                        FLIGHT STATUS
                                    </h4>
                                    <h4 class="dark-text bold font-md">
                                      
                                    </h4>
                                </div>
                                <div class="cmd">
                                    <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightOpen' disabled={open} onClick={() => { !open && fncFlightOptions("Open") }}>Open  </a> 
                                    
                                    <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightClosePending' disabled={closePending} onClick={() => { !closePending && fncFlightOptions("ClosePending") }}>Close Pending</a>
                                    
                                    <a class="btn btn-outline-primary dark-text font-sm me-3" id='flightClose' disabled={close} onClick={() => { !close && fncFlightOptions("Close") }}>Close </a>
                                    
                                </div>
                            </div>
                            <button class="btn btn-primary btn-animation" id="loadFlight" onClick={() => loadFlightData()} disabled = {isLoadFlightAvailable}><span class="px-4">Load</span></button>
                            
                        </div> */}
                    </div>
                </div>
            </div>
            {/* gate new modal */}
            <Modal
                show={showGateChangePopup}
                onHide={fncPopupCancelClick}
                backdrop="static"
                keyboard={false}                
            >
                <Modal.Header  >
                    <Modal.Title>Change Gate Number</Modal.Title>
                </Modal.Header>
                            <FocusLock>

                <Modal.Body>
                    <div class="bagform">
                        <div class="form-floating mb-4">
                            <input
                                type="text"
                                class="form-control focusClass"
                                value={gate}
                                id="changeGateNumber"
                                placeholder="changeGateNumber"
                                onChange={(e) => fncChangeGateNumber(e)}
                            />
                            <label class="bold" for="changeGateNumber"
                            >Change Gate Number</label
                            >
                        </div>
                        <div class="d-flex py-3">
                            <input
                                class="me-2 form-check-input checkbox-input"
                                type="checkbox"
                                id="sendNotification"
                                name="documentVerified"
                                onChange={(e) => { fncSendNotification(e) }} checked={sendNotification}
                            />
                            <label
                                for="sendNotification"
                                class="font-md bold dark-text mb-0"
                            >Send Notification</label
                            >
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="focusClass btn btn-red SerachBtn" onClick={() => fncSubmitGateChangeRequest()}>
                        Submit
                    </button>
                    <button className="focusClass btn-cancel btn btn-primary btn-animation SerachBtn" onClick={fncPopupCancelClick}>Cancel</button>
                </Modal.Footer>
                            </FocusLock>
            </Modal>
            {/* <div
                class="modal fade"
                id="changeGate"
                tabindex="-1"
                aria-labelledby="staticBackdropLabel"
                aria-hidden="true"
                data-bs-backdrop="static"
                data-dismiss="modal"
                data-toggle="modal"
            >

                <div class="modal-dialog modal-dialog-centered security-modal seat-modal ">
                    <div class="modal-content">
                        <div class="bagDetails">
                            <div class="">
                                <div
                                    class="d-flex mb-3 justify-content-between align-items-center"
                                >
                                    <div class="heading-content">
                                        <h4 class=" font-xxl bold dark-text mb-1">
                                            Change Gate Number
                                        </h4>
                                    </div>
                                </div>

                                <div class="bagform">
                                    <div class="form-floating mb-4">
                                        <input
                                            type="text"
                                            class="form-control"
                                            value={gate}
                                            id="changeGateNumber"
                                            placeholder="changeGateNumber"
                                            onChange={(e) => fncChangeGateNumber(e)}
                                        />
                                        <label class="bold" for="changeGateNumber"
                                        >Change Gate Number</label
                                        >
                                    </div>
                                    <div class="d-flex py-3">
                                        <input
                                            class="me-2 form-check-input"
                                            type="checkbox"
                                            id="sendNotification"
                                            name="documentVerified"
                                            onChange={(e) => { fncSendNotification(e) }} checked={sendNotification}
                                        />
                                        <label
                                            for="sendNotification"
                                            class="font-md bold dark-text mb-0"
                                        >Send Notification</label
                                        >
                                    </div>
                                </div>

                                <div class="btn-container d-flex justify-content-between">
                                    <a
                                        data-bs-toggle="modal"
                                        data-bs-target="#changeGateSubmit"
                                        data-bs-dismiss="modal"
                                        class="btn-add btn btn-primary btn-animation d-flex justify-content-center"
                                        onClick={() => fncSubmitGateChangeRequest()}
                                    >
                                        <span class="font-md bold">Submit</span>
                                    </a>
                                    <a
                                        data-bs-dismiss="modal"
                                        class="btn-cancel btn btn-outline-primary btn-animation d-flex justify-content-center"
                                    >
                                        <span id="gateChangeCancelButton" class="font-md bold">Cancel</span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> */}
        </div>
    );
}

export default Notification;